import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Site } from '@debbie/common/dist/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import debbieSquare from '../assets/images/debbie-bg.png';
import THEME from '../theme.js';
import Alert from './Alert.js';
import Button from './Button.js';
import Input from './Input.js';
import Loading from './Loading.js';
import PasswordCreator from './login/password_creation/PasswordCreator.js';
import PasswordReset from './login/PasswordReset.js';
import TwoFactor from './login/TwoFactor.js';
import PlaceholderLoader from './PlaceholderLoader.js';
const WelcomeWrapper = styled.div `
  position: fixed;
  z-index: 99999999;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
  transition: transform 0.4s;

  &.hide {
    transform: translateY(-140vh);
  }
`;
const WelcomeContent = styled.div `
  width: 100%;
  max-width: 350px;
  position: relative;

  .loading {
    position: absolute;
    top: 0;
    text-align: center;
    width: 100%;
    padding: 60px;
    /*z-index: -1;*/
  }

  .logo {
    width: 60%;
    margin-bottom: 70px;
  }

  & > div {
    transition:
      opacity 0.4s,
      transform 0.4s;
  }

  .warning {
    border-radius: 3px;
    background-color: #ff5252;
    padding: 12px 15px;
    font-size: 0.8em;
    margin-bottom: 20px;
    width: 100%;
    background-image: none;
    border: 1px solid #ccc;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    color: white;
  }
`;
const ResetWrapper = styled.div `
  text-align: left;
  margin-bottom: 20px;
  margin-top: 10px;
`;
const Welcome = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [collector, setCollector] = useState(null);
    const [passwordResetActive, setPasswordResetActive] = useState(false);
    const [newUserToken, setNewUserToken] = useState(null);
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const authToken = useSelector((s) => s.authToken);
    const twoFactorRequired = useSelector((s) => s.twoFactorRequired);
    let webName;
    switch (site) {
        case Site.Client:
            webName = lang.sites.clientWeb;
            break;
        case Site.Debtor:
            webName = lang.sites.detiorWeb;
            break;
        case Site.Caseworker:
            webName = lang.sites.caseworkerWeb;
            break;
        default:
            webName = '';
            break;
    }
    useEffect(() => {
        const fetchCollector = async () => {
            const domainBase = window.location.hostname;
            if ([
                'client.debbiecollect.com',
                'debtor.debbiecollect.com',
                'localhost',
                '127.0.0.1',
            ].includes(domainBase) &&
                [Site.Debtor, Site.Client].includes(site)) {
                document.title = webName;
                setLoading(false);
                setCollector(null);
            }
            else {
                try {
                    if (!loading && !collector && site !== Site.Caseworker) {
                        setLoading(true);
                        const collector = await collectorsAPI.getBySiteBase(domainBase);
                        if (collector) {
                            setLoading(false);
                            setCollector(collector);
                            document.title = collector.name;
                        }
                    }
                }
                catch (error) {
                    setLoading(false);
                    setCollector(null);
                }
            }
        };
        fetchCollector();
    }, []);
    useEffect(() => {
        setNewUserToken(new URLSearchParams(window.location.search).get('nu_token'));
        if (h.hasData(authToken)) {
            setEmail('');
            setPassword('');
        }
    }, [authToken]);
    const login = () => {
        c.auth.login(email, password);
    };
    return (React.createElement(WelcomeWrapper, { className: `${props.hide ? 'hide ' : ''}fadein`, style: {
            background: `url(${debbieSquare}) no-repeat center center ${THEME.BACKGROUND}`,
            WebkitBackgroundSize: 'cover',
            MozBackgroundSize: 'cover',
            OBackgroundSize: 'cover',
            backgroundSize: 'cover',
        } },
        React.createElement(WelcomeContent, null,
            React.createElement("div", { style: {
                    opacity: h.isLoading(authToken) ? 1 : 0,
                    transform: h.isLoading(authToken)
                        ? 'translateY(0px)'
                        : 'translateY(50px)',
                }, className: "loading" },
                React.createElement(Loading, { style: { width: '100%' } })),
            React.createElement("div", { style: {
                    opacity: h.isLoading(authToken) ? 0 : 1,
                    transform: h.isLoading(authToken)
                        ? 'translateY(-50px)'
                        : 'translateY(0px)',
                } },
                loading ? (React.createElement(PlaceholderLoader, null)) : collector || Site.Caseworker === site ? (React.createElement("img", { src: (collector && collector.logoSrc) || props.logo, className: "logo", alt: "logo", width: "100%" })) : (React.createElement("h1", { style: { margin: '1em 0 2em 0' } }, webName && webName.toUpperCase())),
                h.isError(authToken) ? (React.createElement("div", { className: "warning" }, authToken.error.message)) : null,
                typeof newUserToken == 'string' ? (React.createElement(PasswordCreator, { token: newUserToken })) : passwordResetActive ? (React.createElement(PasswordReset, { onCancel: () => {
                        setPasswordResetActive(false);
                    }, onUpdated: () => {
                        setPasswordResetActive(false);
                    } })) : h.isLoaded(twoFactorRequired) && twoFactorRequired.data ? (React.createElement(TwoFactor, { username: email, password: password })) : (React.createElement(React.Fragment, null,
                    React.createElement("form", { onSubmit: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            login();
                        } },
                        collector &&
                            collector.tenantId ===
                                '416d70d8-96ff-43df-9cb1-72eeca0dfb2c' && (React.createElement(Alert, { message: 'Vi vil aldrig bede om dit password, så hvis du bliver kontaktet af en person, der udgiver sig for at være fra os, og som spørger ind til dine loginoplysninger, så udlevér dem aldrig, men kontakt os straks på telefon 44 22 40 00' })),
                        React.createElement(Input, { onKeyDown: (e) => {
                                if (e.key === 'Enter')
                                    login();
                            }, onChange: (e) => {
                                setEmail(e.target.value);
                            }, className: "inp", value: email, placeholder: lang.users.email }),
                        React.createElement(Input, { onKeyDown: (e) => {
                                if (e.key === 'Enter')
                                    login();
                            }, onChange: (e) => {
                                setPassword(e.target.value);
                            }, className: "inp", type: "password", value: password, placeholder: lang.login.password }),
                        React.createElement(Button, { className: "btn full-width", 
                            /*onClick={this.login}*/
                            block: true, disabled: !(email && password) || h.isLoading(authToken), theme: "light" }, lang.login.login)),
                    React.createElement(ResetWrapper, null,
                        React.createElement(Button, { theme: "text", onClick: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                c.auth.reset();
                                setPasswordResetActive(true);
                            } }, "Nulstil password"))))))));
};
export default Welcome;
//# sourceMappingURL=Welcome.js.map